import { render } from "./TvmServiceOffers.vue?vue&type=template&id=5a56c549&scoped=true"
import script from "./TvmServiceOffers.js?vue&type=script&lang=js&external"
export * from "./TvmServiceOffers.js?vue&type=script&lang=js&external"

import "./TvmServiceOffers.vue?vue&type=style&index=0&id=5a56c549&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a56c549"]])

export default __exports__